export default "/images/vendor/flag-icon-css/flags/1x1/xx.svg?0b7434ecd0bfcce77f8ad5e16ba78bbc";